// extracted by mini-css-extract-plugin
export var content = "_o7-1";
export var fullScreen = "_o7-0";